import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment-with-locales-es6';
import Form from './components/Form';
import BackgroundImage from './components/BackgroundImage';
import Menu from './components/Menu';
import DestinationsFlights from './components/DestinationsFlights';
import OriginFlights from './components/OriginFlights';
import PassengersMenu from './components/PassengersMenu';
import RoomsMenu from './components/RoomsMenu';
import packages from './packages';
import { getText, getLang, getParamByName } from './config';

import 'react-datepicker/dist/react-datepicker.css';

const img_url = window.location.protocol.indexOf('https') !== -1 ? 'https://smartair-image.travelyo-cdn.site/custom/iframe-library/' : 'http://img.smartair.co.il/custom/iframe-library/';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            baseUrl: getLang() === 'en' ? (getParamByName("site") ==='travelcheck' ? 'https://www.travelcheck.co.za' : 'https://www.joombofly.com') : (getParamByName('subdomain') ? window.location.protocol + '//www.' + getParamByName("site") + '.smartair' : window.location.protocol + '//www.smartair') + (getLang() === 'fr' ? '.fr' : '.co.il'),
            engineHash: getParamByName('engine') || 'api_smartair',
            imgPath: (getParamByName('library') === 'external' ? img_url : './img/') + (getParamByName('site') ? getParamByName('site') + '/' : ''),
            searchType: getParamByName('hotelsonly') ? 'hotel' : 'flight',
            originAirport: getParamByName('origin') || 'TLV',
            menuOpened: false,
            datesMenu: false,
            passengersMenu: false,
            roomsMenu: false,
            direction: 'roundtrip',
            direct: false,
            outbound: null,
            inbound: null,
            outboundDate: null,
            inboundDate: null,
            destination: null,
            destinationValue: null,
            destinationInput: '',
            destinationsList: [],
            origin: null,
            originValue: null,
            originInput: '',
            originsLit: [],
            showLoading: false,
            senior: 0,
            adult: 1,
            child: 0,
            baby: 0,
            rooms: [
                {
                    adult: 2,
                    child: 0,
                    baby: 0,
                    senior: 0,
                    childAges: []
                }
            ],
            passengers: {
                senior: 0,
                adult: 1,
                child: 0,
                baby: 0
            },
            passengersSaved: true,
            packages: getText('packages'),
            filteredPackages: [],
            destinations: [],
            origins: getText('origins'),
            filteredDestinations: [],
            filteredOrigins: [],
            errors: {
                origins: false,
                destinations: false,
                outbound: false,
                inbound: false,
                passengers: false
            },
            showError: null,
            isMobile: window.matchMedia("only screen and (max-width: 640px)").matches,
            datesTransition: false
        }
    }
    getFavorite = () => {
        let parent= this;
        let url = getParamByName('url');
        let site = getParamByName('siteId');
        let sei = getParamByName('sei');
        let apiKey = getParamByName('apiKey');
        return fetch( 'https://'+url +'/api/application/favorite?apiKey='+apiKey , {
            method: 'GET'
        }).then((response) => {
            return response.json();
        }).then((data) => {
            parent.setState({
                destinations: data,
                origins: data

            });
            return data;
        })

        return ['oooo'];
    }
    componentWillMount() {
        this.getFavorite ();
        this.updateIsMobile();
    }

    componentDidMount() {
          var title = getParamByName('site');
           title = title.charAt(0).toUpperCase() + title.slice(1);
           document.title = title;
        window.addEventListener("resize", this.updateIsMobile)

        if(getParamByName('city') && getParamByName('cityId')) this.getCityFromUrl()
        if(getParamByName('start_date')) this.getDateFromUrl('outbound')
        if(getParamByName('end_date')) this.getDateFromUrl('inbound')
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateIsMobile)
    }

    getDateFromUrl = (type) => {
        this.setState({
            [type]: getParamByName(type === 'outbound' ? 'start_date' : 'end_date'),
            [type + 'Date']: getParamByName(type === 'outbound' ? 'start_date' : 'end_date')
        });
    }

    getCityFromUrl = () => {
        fetch(window.location.protocol + '//'+ getParamByName('url') +'/ajax/airport.php?site='+ getParamByName('siteid') +'&locale=' + getLang() + '&dynamicPrefix='+ getParamByName('prefix') + '&sei='+ getParamByName('searchengine') +'&search_type=inbound&engine=flight&term=' + getParamByName('city'), {
            method: 'GET'
        }).then((response) => {
            return response.json();
        }).then((data) => {
            const citySelected = data.filter((city) => {
                return city.value === getParamByName('cityId')
            })

            return this.selectDestination(citySelected[0])
        })
    }

    updateIsMobile = () => {
        this.setState({
            isMobile: window.matchMedia("only screen and (max-width: 640px)").matches
        })
    }

    sendForm = () => {
        this.showErrorMsg(null);
        this.clearErrors();

        let destinations = false,
            outbound = false,
            inbound = false,
            passengers = false;

        if(!this.state.destination) destinations = true;
        if(!this.state.outboundDate) outbound = true;
        if(!this.state.inboundDate && this.state.direction !== 'oneway') inbound = true;
        if(!this.validatePassengers()) passengers = true;

        setTimeout(() => {
            this.setState({
                errors: { destinations, outbound, inbound, passengers }
            })
        }, 100)

        console.log(!destinations, !outbound, !inbound, !passengers);

        if(!destinations && !outbound && !inbound && !passengers) {
            this.state.searchType === 'flight' ? this.openNewWindowFlight() : this.openNewWindowPackage();
        }
    }

    openNewWindowFlight = () => {
        const { adult, child, baby, senior } = this.state.passengers;

        let { outboundDate, inboundDate, engineHash, baseUrl, direction, destinationValue, direct, originValue } = this.state;

        outboundDate = outboundDate.split('-');
        outboundDate = outboundDate[2] + '/' + outboundDate[1] + '/' + outboundDate[0];

        if (this.state.direction !== 'oneway') {
            inboundDate = inboundDate.split('-');
            inboundDate = inboundDate[2] + '/' + inboundDate[1] + '/' + inboundDate[0];
        }

        if (originValue == null || originValue == '') {
            originValue = getParamByName('outbound');
        }


        const url = baseUrl + '/flight-search?' + (getParamByName('utm_source') ? 'utm_source=' + (getParamByName('utm_source') + '&') : '') +
            'utm_medium=' + getParamByName('utm_medium') + '&aff=' + getParamByName('aff') +
            '&outbound_airport_code=' + originValue + '&inbound_airport_code=' + destinationValue +
            '&outbound_date=' + outboundDate + '&inbound_date=' + inboundDate +
            '&direct_only=' + (direct ? '1' : '0') + '&nb_adults=' + adult + '&nb_seniors=' + senior +
            '&nb_childs=' + child + '&nb_babies=' + baby + '&roundtrip=' + (direction === 'roundtrip' ? '1' : '0') +
            '&open_jaw=0&unique_id=40&search_engine_hash=' + engineHash;
        

        var win = window.open(url, '_blank');

        win.focus();
    }

    openNewWindowPackage = () => {
        const outbound = moment(this.state.outboundDate);
        const inbound = moment(this.state.inboundDate);
        const duration = inbound.diff(outbound, 'days');
        let rooms = '';

        this.state.rooms.map((room, id) => {
            const roomNumber = 'rooms[' + (id+1) + ']';
            let childAges = '';
            room.childAges.map((age) => {
                childAges = childAges + '' + age + ','
            })
            rooms = rooms + '&' + roomNumber + '[adults]=' + room.adult +
                '&' + roomNumber + '[children]=' + room.child +
                '&' + roomNumber + '[seniors]=' + room.senior +
                '&package_search_form[rooms][' + (id+1) + '][age_childrens]=' + childAges +
                '&package_search_form[rooms][' + (id+1) + '][babies]=' + room.baby
        })

        const url = this.state.baseUrl + '/dynamic-package/customize/directSearch?' + (getParamByName('utm_source') ? 'utm_source=' + (getParamByName('utm_source') + '&') : '') + 'package_slug=' + this.state.destinationValue + '' +
            '&airport_code=' + (getParamByName('outbound') || 'TLV') + '&departure_date=' + this.state.outboundDate + '&steps[0][duration]=' + duration + '&duration=' + duration + '' +
            rooms + '&directSearch=1&utm_medium=' + getParamByName('utm_medium') + '&aff=' + getParamByName('aff');

        const target = getParamByName('hotelsonly') ? '_self' : '_blank'

        if(getParamByName('hotelsonly')) {
            this.setState({
                showLoading: true
            })
        }

        var win = window.open(url, target);

        win.focus();
    }

    getRoomsTotal = () => {
        const rooms = this.state.rooms;
        let total = 0;

        rooms.map((room) => {
            total = total + room.adult + room.child + room.senior
        });

        return total;
    }

    resetAllMenus = () => {
        this.setState({
            datesMenu: false,
            roomsMenu: false,
            menuOpened: false,
            passengersMenu: false,
            editDestination: false,
            editOrigin: false,
            destinationInput: '',
            originInput: '',
            showError: null
        })
    }

    validatePassengers = () => {
        if(this.state.searchType === 'flight') {
            const { adult, child, baby, senior } = this.state.passengers;

            return (!!(adult || child || baby || senior));
        } else {
            return this.getRoomsTotal() > 0 && this.state.passengersSaved
        }
    }

    clearErrors = () => {
        this.showErrorMsg(null);
        this.setState({
            errors: {
                origins: false,
                destinations: false,
                outbound: false,
                inbound: false,
                passengers: false
            }
        })
    }

    showDates = (dates) => {
        this.resetAllMenus();

        this.setState({
            datesMenu: dates,
            datesTransition: false
        })
    }

    showRooms = (show) => {
        this.resetAllMenus();

        this.setState({
            roomsMenu: show,
        })
    }

    openMenu = (menu) => {
        this.resetAllMenus();

        this.setState({
            editDestination: !!menu && !this.state.isMobile && menu === 'destinations',
            editOrigin: !!menu && !this.state.isMobile && menu === 'origins',
            menuOpened: menu,
        })
    }

    showPassengers = () => {
        this.resetAllMenus();

        this.setState({
            passengersMenu: !this.state.passengersMenu,
        })
    }

    onDirectChange = () => {
        this.showErrorMsg(null);
        this.setState({
            direct: !this.state.direct
        });
    }

    onDirectionChange = (e) => {
        this.showErrorMsg(null);
        this.setState({
            direction: e.target.value
        });
    }

    selectDestination = (destination) => {
        this.resetAllMenus();

        this.setState({
            destination: destination.label,
            destinationValue: destination.airport_code,
            filteredDestinations: [],
            filteredPackages: []
        })
    }

    selectOrigin = (origin) => {
        this.resetAllMenus();

        this.setState({
            origin: origin.label,
            originValue: origin.airport_code,
            filteredOrigins: [],
            filteredPackages: []
        })
    }

    selectOutbound = (date) => {
        this.showErrorMsg(null);
        if(this.state.isMobile) {
            this.setState({
                outbound: date.format('YYYY-MM-DD'),
                outboundDate: date.format('YYYY-MM-DD'),
                inbound: null,
                datesMenu: false
            });
        }
        else {
            if (this.state.direction === 'roundtrip') {
                this.setState({
                    datesTransition: true,
                    outbound: date.format('YYYY-MM-DD'),
                    outboundDate: date.format('YYYY-MM-DD'),
                    inbound: null
                });

                setTimeout(() => {
                    this.setState({
                        datesMenu: 'inbound'
                    })
                }, 400)
            } else {
                this.setState({
                    outbound: date.format('YYYY-MM-DD'),
                    outboundDate: date.format('YYYY-MM-DD'),
                    datesMenu: false
                });
            }
        }
    }

    selectInbound = (date) => {
        this.showErrorMsg(null);
        this.setState({
            inbound: date.format('YYYY-MM-DD'),
            inboundDate: date.format('YYYY-MM-DD'),
            datesMenu: false,
            datesTransition: false
        })
    }

    saveOutbound = () => {
        this.showErrorMsg(null);
        if(this.state.outbound) {
            this.setState({
                outboundDate: this.state.outbound,
                datesMenu: false,
                datesTransition: false
            })
        }
    }

    saveInbound = () => {
        this.showErrorMsg(null);
        if(this.state.inbound) {
            this.setState({
                outboundDate: this.state.outbound,
                inboundDate: this.state.inbound,
                datesMenu: false,
                datesTransition: false
            })
        }
    }

    savePassengers = () => {
        this.showErrorMsg(null);
        const { adult, child, baby, senior } = this.state;

        this.setState({
            passengers: {
                adult: this.state.adult,
                child: this.state.child,
                baby: this.state.baby,
                senior: this.state.senior
            },
            passengersSaved: adult || child || baby || senior,
        })
    }

    isFormCollapsed = () => {
        return this.state.menuOpened || this.state.datesMenu || this.state.passengersMenu || this.state.roomsMenu;
    }

    getFlightTotal = (id) => {
        return this.state.adult + this.state.child + + this.state.senior;
    }

    showErrorMsg = (error) => {
        this.setState({
            showError: error
        })
    }

    plusClick = (type) => {
        this.showErrorMsg(null);
        if((type === 'child' || type === 'baby') && (this.state.adult === 0 && this.state.senior === 0)) return this.showErrorMsg(getText('childWithAdultError'));

        if(type === 'baby' && (this.state.adult <= this.state.baby)) return this.showErrorMsg(getText('babyWithAdultError'));

        if((this.getFlightTotal() < 9) || (type === 'baby' && this.state.baby < this.state.adult)) {
            this.setState({
                [type]: this.state[type] + 1,
                passengers: Object.assign(this.state.passengers, { [type]: this.state[type] + 1 }),
                passengersSaved: true
            })
        }

        else if(this.getFlightTotal() >= 9) this.showErrorMsg(getText('maxPassengersError'))
        else if(type === 'baby' && this.state.baby >= this.state.adult) this.showErrorMsg(getText('babyWithAdultError'))
    }

    minusClick = (type) => {
        this.showErrorMsg(null);
        if((type === 'adult' && this.state.adult === 1 && this.state.senior === 0) || (type === 'senior' && this.state.senior === 1 && this.state.adult === 0)) {
            this.showErrorMsg(getText('childWithAdultError'));

            this.setState({
                child: 0,
                baby: 0,
                passengers: Object.assign(this.state.passengers, { child: 0, baby: 0 })
            })
        }

        if(type === 'adult' && (this.state.adult === this.state.baby) && this.state.adult > 0) {
            this.showErrorMsg(getText('babyWithAdultError'));
            this.setState({
                baby: this.state.baby - 1,
                passengers: Object.assign(this.state.passengers, { baby: this.state.baby - 1 })
            })
        };

        if(this.state[type] > 0) {
            this.setState({
                [type]: this.state[type] - 1,
                passengers: Object.assign(this.state.passengers, { [type]: this.state[type] - 1 }),
            })
        }

        setTimeout(() => {
            if(this.getFlightTotal() === 0) {
                this.setState({ passengersSaved: false })
            }
        }, 200)
    }

    onDestinationInput = (e) => {
        //if(!this.state.isMobile) clearTimeout(this.typingBuffer);
        const value = e.target.value;

        this.setState({
            destinationInput: value
        });

        //this.typingBuffer = setTimeout(() => {
        fetch(window.location.protocol + '//'+ getParamByName('url') +'/ajax/airport.php?site='+ getParamByName('siteid') +'&locale=' + getLang() + '&dynamicPrefix='+ getParamByName('prefix') +'&sei='+ getParamByName('searchengine') +'&search_type=inbound&engine=flight&term=' + value, {
            method: 'GET'
        }).then((response) => {
           return response.json();
        }).then((data) => {
            this.setState({
                filteredDestinations: data
            });
        });
        //}, 300)
    }

    onOriginInput = (e) => {
        const value = e.target.value;

        this.setState({
            originInput: value
        });

        fetch(window.location.protocol + '//'+ getParamByName('url') +'/ajax/airport.php?site='+ getParamByName('siteid') +'&locale=' + getLang() + '&dynamicPrefix='+ getParamByName('prefix') + '&sei='+ getParamByName('searchengine') +'&search_type=outbound&engine=flight&term=' + value, {
            method: 'GET'
        }).then((response) => {
           return response.json();
        }).then((data) => {
            this.setState({
                filteredOrigins: data
            });
        });
    }

    onDestinationInputHotel = (e) => {
        const value = e.target.value;

        this.setState({
            destinationInput: value
        });

        let data = packages.filter(item => {
            return item.label.indexOf(value) === 0;
        })

        this.setState({
            filteredPackages: data
        })
    }

    changeSearchType = (type) => {
        if(type !== this.state.searchType) {
            this.resetAllMenus()

            this.setState({
                searchType: type,
                passengersSaved: type !== 'flight',
                direction: 'roundtrip',
                destination: null,
                destinationValue: null,
                filteredDestinations: [],
                filteredPackages: []
            })
        }
    }

    clearDestinationInput = () => {
        this.setState({
            destinationInput: '',
            filteredDestinations: [],
            filteredPackages: [],
            menuOpened: false
        })
    }

    saveRooms = (rooms) => {
        this.showErrorMsg(null);
        this.setState({
            rooms,
            passengersSaved: rooms.length > 0
        })
    }

    render() {
        let selectedDate = moment(),
            minDate = moment(),
            saveButton = this.saveOutbound;

        if(this.state.datesMenu === 'outbound') {
            selectedDate = this.state.outbound ? moment(this.state.outbound) : moment()
        } else if (this.state.datesMenu === 'inbound') {
            saveButton = this.saveInbound;
            if(this.state.outbound) {
                selectedDate = null
                minDate = moment(this.state.outbound)
            }
            if(this.state.inbound) {
                selectedDate = moment(this.state.inbound)
            }
        }

        let arrowClass = "";

        if(this.state.datesMenu) arrowClass = "dates-arrow";
        if(this.state.passengersMenu) arrowClass = "passengers-arrow";
        if(this.state.roomsMenu) arrowClass = "passengers-arrow";
        if(this.state.menuOpened) arrowClass = "destinations-arrow";

        return (
            <div className="container">
                <div className={"loading" + (this.state.showLoading ? ' show' : '')}></div>
                <Form
                    arrowClass={arrowClass}
                    collapse={this.isFormCollapsed()}
                    openMenu={this.openMenu}
                    showDates={this.showDates}
                    onOriginInput={this.onOriginInput}
                    onDestinationInput={this.onDestinationInput}
                    onDestinationInputHotel={this.onDestinationInputHotel}
                    clearDestinationInput={this.clearDestinationInput}
                    onDirectionChange={this.onDirectionChange}
                    onDirectChange={this.onDirectChange}
                    showPassengers={this.state.searchType === 'flight' ? this.showPassengers : this.showRooms}
                    sendForm={this.sendForm}
                    changeSearchType={this.changeSearchType}
                    {...this.state}
                />
                <BackgroundImage />
                <Menu
                    show={this.state.menuOpened === 'destinations'}
                    isStart={true}
                    closeHandler={this.openMenu.bind(this, false)}
                    headerClass="select-destinations-header"
                    headerText={getText('destinationsHeader')}
                    hideSave={true} >
                    {this.state.searchType === 'flight' && <DestinationsFlights
                        destinations={this.state.filteredDestinations.length > 0 || this.state.destinationInput ? this.state.filteredDestinations : this.state.destinations.slice(0, (this.state.isMobile ? 6 : this.state.destinations.length))}
                        selectDestination={this.selectDestination}
                        destinationInput={this.state.destinationInput}
                        onDestinationInput={this.onDestinationInput}
                        destination={this.state.destination}
                        placeholderText={getText('destinationsInputPlaceholder')}
                    />}
                    {this.state.searchType === 'hotel' && <DestinationsFlights
                        destinations={this.state.filteredPackages.length > 0 || this.state.destinationInput ? this.state.filteredPackages : this.state.packages.slice(0, (this.state.isMobile ? 6 : this.state.packages.length))}
                        selectDestination={this.selectDestination}
                        destinationInput={this.state.destinationInput}
                        searchType={this.state.searchType}
                        destination={this.state.destination}
                        onDestinationInput={this.onDestinationInputHotel}
                        placeholderText={getText('packagesInputPlaceholder')}
                    />}
                </Menu>
                <Menu
                    show={this.state.menuOpened === 'origins'}
                    isStart={true}
                    closeHandler={this.openMenu.bind(this, false)}
                    headerClass="select-destinations-header"
                    headerText={getText('originHeader')}
                    hideSave={true} >
                    <OriginFlights
                        origins={this.state.filteredOrigins.length > 0 || this.state.originInput ? this.state.filteredOrigins : this.state.origins.slice(0, (this.state.isMobile ? 6 : this.state.origins.length))}
                        selectOrigin={this.selectOrigin}
                        originInput={this.state.originInput}
                        onDestinationInput={this.onOriginInput}
                        origin={this.state.origin}
                        placeholderText={getText('destinationsInputPlaceholder')}
                    />
                </Menu>
                <Menu
                    show={this.state.datesMenu !== false}
                    small={true}
                    datesTransition={this.state.datesTransition}
                    closeHandler={this.showDates.bind(this, false)}
                    saveHandler={saveButton}
                    headerText={(this.state.datesMenu === 'outbound' ? getText('selectOutboundDate') : getText('selectInboundDate'))}
                    headerClass="select-dates-header"
                    hideSave={true} >
                    <DatePicker
                        inline
                        selected={selectedDate}
                        minDate={minDate}
                        locale={getText('datesLocale')}
                        maxDate={moment().add(1, "years").subtract(1, "month").endOf('month')}
                        onChange={(this.state.datesMenu === 'outbound' ? this.selectOutbound : this.selectInbound)}
                    />
                </Menu>
                <Menu
                    show={this.state.passengersMenu !== false}
                    small={true}
                    closeHandler={this.showPassengers.bind(this, false)}
                    saveHandler={this.showPassengers.bind(this, false)}
                    headerText={getText('passengersSelectHeader')}
                    headerClass="select-passengers-header">
                    <PassengersMenu
                        {...this.state}
                        plusClick={this.plusClick}
                        minusClick={this.minusClick} />
                </Menu>
                <Menu
                    show={this.state.roomsMenu !== false}
                    big
                    closeHandler={this.showRooms.bind(this, false)}
                    saveHandler={this.showRooms.bind(this, false)}
                    hideSave={this.state.isMobile}
                    headerText={getText('roomsSelectHeader')}
                    headerClass="select-passengers-header">
                    <RoomsMenu
                        {...this.state}
                        rooms={this.state.rooms}
                        closeHandler={this.showRooms.bind(this, false)}
                        saveHandler={this.saveRooms}
                        isMobile={this.state.isMobile}
                        searchType={this.state.searchType}
                        showErrorMsg={this.showErrorMsg}
                    />
                </Menu>
                {this.state.showError &&
                    <div className="errorMessage">
                        <span>{this.state.showError}</span>
                        <div className="errorMessageClose" onClick={() => this.showErrorMsg(null)}>X</div>
                    </div>
                }
            </div>
        );
    }
}

export default App;


//http://www.smartair.co.il/dynamic-package/customize/directSearch?package_slug=new-york-package&airport_code=TLV&departure_date=2018-01-01&steps[0][duration]=4&duration=4&rooms[1][adults]=2&rooms[1][children]=0&rooms[1][seniors]=0&package_search_form[rooms][1][age_childrens]=&package_search_form[rooms][1][babies]=0&directSearch=1
//http://www.smartair.co.il/dynamic-package/customize/directSearch?package_slug=new-york-package&airport_code=TLV&departure_date=2017-12-19&steps[0][duration]=10&duration=10&rooms[1][adults]=2&rooms[1][children]=0&rooms[1][seniors]=0&package_search_form[rooms][1][age_childrens]=&package_search_form[rooms][1][babies]=0&directSearch=1



// WEBPACK FOOTER //
// ./src/App.js